import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { ReportService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class ReportDownloadExcelResolve implements Resolve<any> {

  constructor(private reportService: ReportService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.reportService.downloadExcel(
      route.data.id || route.params.id || route.queryParams.id
    );
  }
}
